import NewsDetailPage from "./components/NewsDetailsPage";
// import PostDetailsComponent from "./components/PostDetailsComponent";
import { About } from "./pages/aboutUs/about";
import { Culture } from "./pages/culture/Culture";
import { Brand } from "./pages/culture/OurBrand";
import { Insights } from "./pages/culture/OurInsights";
import { Lifestyle } from "./pages/culture/OurLifestyle";
import { People } from "./pages/culture/OurPeople";
import { Recognitions } from "./pages/culture/OurRecognition";
import Gallery from "./pages/gallery/Gallery";
import { Health } from "./pages/healthAndWellness/health";
import { Home } from "./pages/home/Home";
import { Leadership } from "./pages/leadership/Leadership";
import NotFound from "./pages/notFound/NotFound";
import Articles from "./pages/press/Articles";
import { Press } from "./pages/press/Press";
import PressReleases from "./pages/press/PressReleases";
import { Reports } from "./pages/ReportsDownload/ReportsDownload";
import { Services } from "./pages/services/Services";
import { Sports } from "./pages/sports/sports";
import { Sustainability } from "./pages/sustainability/Sustainability";
import Portfolio from "./pages/portfolio/Portfolio";
import ProjectDetails from "./pages/portfolio/ProjectDetails";

const { Routes, Route } = require("react-router-dom");

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/sustainability/leadership" element={<Leadership />} />
      <Route path="/culture" element={<Culture />} />
      <Route path="/about" element={<About />} />
      <Route path="/our-brand" element={<Brand />} />
      <Route path="/our-people" element={<People />} />
      <Route path="/our-recognitions" element={<Recognitions />} />
      <Route path="/our-lifestyle" element={<Lifestyle />} />
      <Route path="/our-insights" element={<Insights />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/sustainability/health" element={<Health />} />
      <Route path="/sustainability/sports" element={<Sports />} />
      <Route path="/sustainability" element={<Sustainability />} />
      <Route path="/news" element={<Press />} />
      <Route path="/news/press-releases" element={<PressReleases />} />
      <Route path="/news/articles" element={<Articles />} />
      <Route path="/news/:slug" element={<NewsDetailPage />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/portfolio/:slug" element={<ProjectDetails />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
